import React, { createContext, useContext, useState } from 'react';
import { useTheme } from './ThemeContext';
import { translationsReady } from '../I18n/config';

const AppLoadingContext = createContext();

export function AppLoadingProvider({ clientId, children }) {
  const { loading: themeLoading } = useTheme();
  const [i18nLoading, setI18nLoading] = useState(true);
  const [error, setError] = useState(null);

  // Aguarda as traduções do tenant terminarem de carregar (não apenas o i18next
  // "core" inicializar, que acontece quase instantaneamente com os JSONs de
  // fallback do bundle) — translationsReady sempre resolve, nunca rejeita.
  React.useEffect(() => {
    let cancelled = false;

    translationsReady.finally(() => {
      if (!cancelled) {
        setI18nLoading(false);
      }
    });

    return () => {
      cancelled = true;
    };
  }, []);

  const isLoading = themeLoading || i18nLoading;

  return (
    <AppLoadingContext.Provider value={{ isLoading, error }}>
      {children}
    </AppLoadingContext.Provider>
  );
}

export function useAppLoading() {
  return useContext(AppLoadingContext);
} 
